module.exports = __webpack_public_path__ + "4382c0dd4458b65c895adc5b96cb5611.png";